import { useEffect, useId } from "react";
import PlusNudge from "./PlusNudge.jsx";
import { useI18n } from "../i18n.jsx";
import { usePlus } from "../plus/PlusProvider.jsx";

const AD_CLIENT = "ca-pub-1004596399012650";
const AD_SLOT = "4184101984";

function isLocalAdPreview() {
  const hostname = window.location.hostname;
  return hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1";
}

export default function AdSlot({ position }) {
  const { t } = useI18n();
  const label = position === "top" ? t("ad.top") : t("ad.bottom");
  const adId = useId();
  const { isAdFree } = usePlus();

  useEffect(() => {
    if (isAdFree || isLocalAdPreview()) return;
    try {
      window.adsbygoogle = window.adsbygoogle || [];
      window.adsbygoogle.push({});
    } catch {
      // Ad blockers or local dev can block AdSense; the reserved slot still prevents layout shift.
    }
  }, [adId, isAdFree]);

  if (isAdFree) return null;

  return (
    <aside className={`ad-slot ad-slot-${position}`} aria-label={label}>
      <ins
        key={adId}
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client={AD_CLIENT}
        data-ad-slot={AD_SLOT}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
      <span className="ad-slot-fallback">{t("ad.label")}</span>
      <PlusNudge className="ad-slot-plus-nudge" source="adslot-plus">
        {t("ad.remove")}
      </PlusNudge>
    </aside>
  );
}
